import axios from 'axios'

import { LegalTextsBody, LegalText } from '../model/legal.model'

export default class LegalService {
  constructor(private host: string) {}

  fetchLegalTexts({
    body,
    tenant,
    saleType,
  }: {
    body: LegalTextsBody
    tenant: string
    saleType: string
  }): Promise<LegalText> {
    return axios
      .post(`${this.host}/legal/v1/${tenant}/legal-texts/${saleType}`, body)
      .then((res) => res.data)
  }
}
